module.exports = __webpack_public_path__ + "img/2.ee3ee87d.png";